import {
  FormattedShopifyCollection,
  FormattedShopifyProduct
} from '@portal/types/shopify/product.formatted.types';
import { getShopifyCustomMetafield } from '../../shopify/getShopifyCustomMetafield';

export const getUrlMetafield = (bundle: FormattedShopifyCollection) => {
  return getShopifyCustomMetafield(bundle, 'url');
};

export const getCurrentPriceMetafield = (bundle: FormattedShopifyCollection) => {
  return getShopifyCustomMetafield(bundle, 'current_price');
};

export const getOriginalPriceMetafield = (bundle: FormattedShopifyCollection) => {
  return getShopifyCustomMetafield(bundle, 'original_price');
};

export const getLabelMetafield = (bundle: FormattedShopifyCollection) => {
  return getShopifyCustomMetafield(bundle, 'label');
};

export const getChargeFrequencyMetafield = (bundle: FormattedShopifyCollection) => {
  return getShopifyCustomMetafield(bundle, 'frequency_note');
};

export const getOriginalPriceFootnoteMetafield = (bundle: FormattedShopifyCollection) => {
  return getShopifyCustomMetafield(bundle, 'original_price_footnote');
};

export const getCoreProductQuantityMetafield = (bundle: FormattedShopifyCollection) => {
  return getShopifyCustomMetafield(bundle, 'core_product_quantity');
};

export const getCoreProductSellingPlanIdMetafield = (bundle: FormattedShopifyCollection) => {
  return getShopifyCustomMetafield(bundle, 'core_product_selling_plan_id');
};

export const getBundleSpecificCoreProductAlternativeTitleMetafield = (
  bundle: FormattedShopifyCollection
) => {
  return getShopifyCustomMetafield(bundle, 'core_product_alternative_title');
};

export const getBundleSpecificCoreProductServingsDescriptionMetafield = (
  bundle: FormattedShopifyCollection
) => {
  return getShopifyCustomMetafield(bundle, 'core_product_servings_description');
};

export const getCurrentPricePrefixMetafield = (bundle: FormattedShopifyCollection) => {
  return getShopifyCustomMetafield(bundle, 'current_price_prefix');
};

export const getShortDescriptionMetafield = (product: FormattedShopifyProduct) => {
  return getShopifyCustomMetafield(product, 'short_description');
};

export const getAlternativeTitleMetafield = (product: FormattedShopifyProduct) => {
  return getShopifyCustomMetafield(product, 'alternative_title');
};

export const getUseCustomBundleServingsDescriptionMetafield = (
  product: FormattedShopifyProduct
) => {
  return getShopifyCustomMetafield(product, 'use_custom_bundle_servings_description');
};
